<script lang="ts" setup>
import { useCoreStore } from '@apps/main/new-desktop/core/stores';

import { AppImagesLoader, AppLazyLoadComponent } from '@libs/ui';

interface FerryCardHeaderProps {
  logoUrls: string[];
  fromPortLabel?: string;
  toPortLabel?: string;
}
const props = defineProps<FerryCardHeaderProps>();

interface FerryCardHeaderEmits {
  (eventName: 'show-details'): void;
}

const emit = defineEmits<FerryCardHeaderEmits>();

const coreStore = useCoreStore();
</script>

<template>
  <div class="ferry-card-header">
    <div class="top-row">
      <div class="ferry-logo">
        <AppLazyLoadComponent class="logo">
          <AppImagesLoader
            :key="props.logoUrls.join('-')"
            :urls="props.logoUrls"
            alt="ferry carrier logo"
            img-type="scaleX"
            @images-loader-error="coreStore.handleImageLoadError"
          />
        </AppLazyLoadComponent>
      </div>
      <button class="details" @click="emit('show-details')">
        {{ $t('planner.details') }}
      </button>
    </div>
    <div class="destinations">
      {{ props.fromPortLabel }}
      &mdash;
      {{ props.toPortLabel }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.ferry-card-header {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-12);

  .top-row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    .ferry-logo {
      height: 30px;
      box-sizing: content-box;
    }

    .details {
      all: unset;
      display: flex;
      @include font-label-l-light;
      text-decoration: underline;
      cursor: pointer;
      position: absolute;
      right: 0;
    }
  }

  .destinations {
    display: none;
    @include font-label-s-light;
    @include for-less-or-equal-than-599-px {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-secondary-60);
    }
  }
}
</style>
